import React, { Component } from 'react';
import TreasuryController from './treasury.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Layout } from '../common';
import { DatePicker, Divider, Skeleton } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import FundsInAccount from './elements/FundsInAccount';
import FundingRecommendation from './elements/FundingRecommendation';
import KPICard from './elements/KPICard';
import CashFlowChart from './elements/CashFlowChart';
import ReceivablesAging from './elements/ReceivablesAging';
import styles from './treasury.module.scss';

const { RangePicker } = DatePicker;

class Treasury extends Inherit(TreasuryController, Component) {
    state = { 
        user: {}, 
        loading: true,
        fundsData: null,
        fundsLoaded: false,
        recommendationData: null,
        recommendationLoaded: false,
        kpiData: null,
        kpiLoaded: false,
        agingData: null,
        agingLoaded: false,
        cashFlowData: null,
        cashFlowLoaded: false,
        dateRange: null,
    };

    render() {
        const { 
            loading,
            fundsData, fundsLoaded,
            recommendationData, recommendationLoaded,
            kpiData, kpiLoaded,
            agingData, agingLoaded,
            cashFlowData, cashFlowLoaded,
            user,
            dateRange
        } = this.state;

        return (
            <Layout user={user} fi={user?.fi?.name}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <h1 className={styles.title}>Cashflow Management</h1>
                    </div>

                    <div className={styles.topRow}>
                        <div className={styles.fundsSection}>
                            {fundsLoaded && kpiLoaded ? (
                                <FundsInAccount 
                                    total={fundsData.fundsInAccount}
                                    advanced={kpiData.totalAdvanced}
                                    overdue={kpiData.overdueFunds}
                                    available={fundsData.fundsInAccount}
                                />
                            ) : (
                                <div style={{ background: '#fff', padding: '24px', borderRadius: '12px' }}>
                                    <Skeleton active paragraph={{ rows: 0 }} />
                                    <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 2 }} />
                                </div>
                            )}
                        </div>
                        <div className={styles.recommendationSection}>
                            {recommendationLoaded ? (
                                <FundingRecommendation 
                                    min={recommendationData.suggestedMin}
                                    max={recommendationData.suggestedMax}
                                    activeUsers={recommendationData.activeUsers}
                                    advancesPerUser={recommendationData.advancesPerUser}
                                    volumePerAdvance={recommendationData.volumePerAdvance}
                                />
                            ) : (
                                <div style={{ background: '#fff', padding: '24px', borderRadius: '12px' }}>
                                    <Skeleton active paragraph={{ rows: 0 }} />
                                    <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 3 }} />
                                </div>
                            )}
                        </div>
                    </div>

                    <Divider className={styles.divider} />

                    <div className={styles.kpiSection}>
                        <div className={styles.kpiHeader}>
                            <h2 className={styles.kpiTitle}>Treasury Account KPIs</h2>
                            {/* <RangePicker 
                                value={dateRange}
                                onChange={(dates) => this.handleDateChange(dates)}
                                suffixIcon={<CalendarOutlined />}
                                size="large"
                                className={styles.datePicker}
                            /> */}
                        </div>
                        <div className={styles.kpiRow}>
                            {kpiLoaded ? (
                                <>
                                    <KPICard 
                                        title="Total Advanced Funds"
                                        value={kpiData.totalAdvanced}
                                        changePercent={kpiData.totalAdvancedChange}
                                        format="currency"
                                        index={0}
                                    />
                                    <KPICard 
                                        title="Overdue Funds"
                                        value={kpiData.overdueFunds}
                                        changePercent={kpiData.overdueFundsChange}
                                        format="currency"
                                        index={1}
                                    />
                                    <KPICard 
                                        title="Overdue Users"
                                        value={kpiData.overdueUsers}
                                        changePercent={kpiData.overdueUsersChange}
                                        format="number"
                                        index={2}
                                    />
                                    <KPICard 
                                        title="Avg. Overdue Period"
                                        value={kpiData.avgOverduePeriod}
                                        changePercent={kpiData.avgOverduePeriodChange}
                                        format="days"
                                        index={3}
                                    />
                                </>
                            ) : (
                                <>
                                    {[0, 1, 2, 3].map(index => (
                                        <div key={index} style={{ background: '#fff', padding: '24px', borderRadius: '12px' }}>
                                            <Skeleton active paragraph={{ rows: 0 }} />
                                            <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 1 }} />
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>

                    <div className={styles.chartsRow}>
                        <div className={styles.cashFlowSection}>
                            {cashFlowLoaded ? (
                                <CashFlowChart data={cashFlowData} />
                            ) : (
                                <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', height: '400px' }}>
                                    <Skeleton active paragraph={{ rows: 8 }} />
                                </div>
                            )}
                        </div>
                        <div className={styles.agingSection}>
                            {agingLoaded ? (
                                <ReceivablesAging data={agingData} />
                            ) : (
                                <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', height: '400px' }}>
                                    <Skeleton active paragraph={{ rows: 8 }} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default withHooks(Treasury);
